import React, { useState } from "react";
import SensorCard from "../../components/sensors/SensorCard";
import SensorHistory from "../../components/sensors/SensorHistory";
import { useSensorList } from "../../features/sensors/useSensors";
import { pickSensor } from "../../features/sensors/sensorRules";
import "../mobile.css";

// The phone Shop sensors page (/sensors, where the alert pushes land): a card per sensor (tap one
// to chart it), the chart with 24 h / 7 days / 30 days, and the alert history. Read only: the
// settings, test alert, tokens and new sensors stay on the desktop page. Layout only:
// features/sensors/ (reads + words), components/sensors/ (the card and the chart, shared with the desktop).

export default function SensorsScreen() {
  const { sensors, error } = useSensorList();
  const [wantedId, setWantedId] = useState(null);
  const selected = pickSensor(sensors, wantedId);
  const stamp = selected ? `${selected.last_reading_at || ""}|${selected.last_alert_at || ""}` : "";

  if (sensors === null && !error) {
    return (
      <div className="jq-list-state" role="status" data-testid="phone-sensors">
        <span className="spinner-border spinner-border-sm" aria-hidden="true" />
      </div>
    );
  }

  return (
    <div className="jq-screen" data-testid="phone-sensors">
      {error && (
        <div className="jq-note jq-note-danger" role="alert">
          {sensors && sensors.length ? `Showing the last answer: ${error}` : error}
        </div>
      )}
      {sensors && sensors.length === 0 && !error && (
        <div className="jq-list-state">No sensors are registered yet.</div>
      )}
      {(sensors || []).map((s) => (
        <div key={s.sensor_id} className="mb-2">
          <SensorCard sensor={s} selected={selected && selected.sensor_id === s.sensor_id}
                      onSelect={sensors.length > 1 ? setWantedId : undefined} />
        </div>
      ))}
      {selected && (
        <div className="jq-card" data-testid="phone-sensor-history">
          <SensorHistory sensor={selected} stamp={stamp} chartHeight={200} compact />
        </div>
      )}
      <div className="jq-muted mt-2 mb-3">Settings, test alerts and new sensors are on the desktop page.</div>
    </div>
  );
}
